import { useMemo, useState } from "react";

import { BorrowInsert } from "store/api/borrow";
import { Grid, useTheme } from "@mui/material";
import { LoadingButton } from '@mui/lab';
import http from "config/http";
import { useFormContext } from "react-hook-form";
import useNotify from "hooks/useNotify";
import { actionButtonBg } from "utils/helpers/actionButtonBg";
import SuccessModal from "components/SuccessModal";

function BorrowSubmit({ onClose }) {
  const notify = useNotify();
  const theme = useTheme()
  
  const { handleSubmit, watch, reset } = useFormContext();
  
  const amount = watch("amount");
  
  const [loading, setLoading] = useState(false)
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false)

  const isButtonDisabled = useMemo(() => !amount, [amount]);

  const onSubmit = async (data) => {
    try {
      setLoading(true)

      await http.post(BorrowInsert, data);
      
      setOpenConfirmationModal(true)
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
    
    setLoading(false)
  };

  return (
    <Grid item xs={12}>
      <LoadingButton
        disabled={isButtonDisabled}
        fullWidth
        variant="contained"
        loading={loading}
        color={actionButtonBg(theme)}
        onClick={handleSubmit(onSubmit)}
      >
        تایید
      </LoadingButton>

      {openConfirmationModal &&
        <SuccessModal
          title={"Loan Borrowed Successfully"}
          subtitle={"Your loan request has been approved and credited to your margin wallet."}
          open={openConfirmationModal}
          onClose={() => {
            reset();
            setOpenConfirmationModal(false)
            onClose()
          }}
        />
      }
    </Grid>
  );
}

export default BorrowSubmit;
